module.exports = __webpack_public_path__ + "static/media/mode-51.d31da1ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-51.svg
// module id = 1005
// module chunks = 2